// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3zEYT","box":"WorkspacesBox_box__gIaLc","node":"WorkspacesBox_node__3t7fq"};